var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    clipPath: "url(#clip0_9675_638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 10.9375C10.5178 10.9375 10.9375 10.5178 10.9375 10C10.9375 9.48223 10.5178 9.0625 10 9.0625C9.48223 9.0625 9.0625 9.48223 9.0625 10C9.0625 10.5178 9.48223 10.9375 10 10.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5625 10.9375C7.08027 10.9375 7.5 10.5178 7.5 10C7.5 9.48223 7.08027 9.0625 6.5625 9.0625C6.04473 9.0625 5.625 9.48223 5.625 10C5.625 10.5178 6.04473 10.9375 6.5625 10.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4375 10.9375C13.9553 10.9375 14.375 10.5178 14.375 10C14.375 9.48223 13.9553 9.0625 13.4375 9.0625C12.9197 9.0625 12.5 9.48223 12.5 10C12.5 10.5178 12.9197 10.9375 13.4375 10.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.24455 16.4929C7.81997 17.4047 9.67321 17.7125 11.4588 17.3588C13.2443 17.0051 14.8403 16.0141 15.9491 14.5706C17.058 13.1271 17.604 11.3295 17.4855 9.51317C17.3669 7.69679 16.5918 5.98552 15.3047 4.69842C14.0176 3.41131 12.3063 2.63622 10.49 2.51765C8.67358 2.39908 6.87607 2.94512 5.43256 4.05398C3.98904 5.16283 2.99806 6.75882 2.64436 8.54436C2.29066 10.3299 2.59839 12.1832 3.51018 13.7586L2.53283 16.6765C2.49611 16.7867 2.49078 16.9048 2.51744 17.0178C2.5441 17.1308 2.60171 17.2341 2.68379 17.3162C2.76588 17.3983 2.8692 17.4559 2.98218 17.4826C3.09516 17.5092 3.21334 17.5039 3.32346 17.4672L6.24455 16.4929Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9675_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarChat);
export default __webpack_public_path__ + "static/media/sidebar-chat.cfcfa8cd4b382ae65f9685b3a9fcacdc.svg";
export { ForwardRef as ReactComponent };